<template>
  <div class="ds-control ds-no-padding el-col" :class="getCss" :style="getStyle" slot-name="default" v-show="show">
    <slot></slot>
  </div>
</template>
<script>
export default dsf.component({
  name: "DsfCol",
  ctrlCaption: "栅格列",
  mixins: [$mixins.layout],
  inject: {
    parentRow: {
      default: null
    }
  },
  props: {
    span: {
      type: Number,
      default: 24
    },
    xs: {
      type: Number,
      default: null
    },
    //≥768px
    sm: {
      type: Number,
      default: null
    },
    //≥992px
    md: {
      type: Number,
      default: null
    },
    //≥1200px
    xl: {
      type: Number,
      default: undefined
    },
    //≥1920px
    lg: {
      type: Number,
      default: null
    },
    offset: {
      type: Number,
      default: null
    },
    slots: {
      type: Array,
      default() {
        return [{ name: "default", controls: [] }];
      }
    },
    height: {
      type: [String, Number],
      default: "auto"
    }
  },
  data() {
    return {
      show: true,
      observer: null
    };
  },
  computed: {
    getSpanNum() {
      let span = this.span;
      let xs = this.xs;
      let sm = this.sm;
      let md = this.md;
      let xl = this.xl;
      let lg = this.lg;
      let offset = this.offset;
      let classList = [this.span ? "el-col-" + span : "", this.xs ? "el-col-xs-" + xs : "", this.sm ? "el-col-sm-" + sm : "", this.md ? "el-col-md-" + md : "", this.xl ? "el-col-xl-" + xl : "", this.lg ? "el-col-lg-" + lg : "", this.offset ? "el-col-offset-" + offset : ""];
      return classList;
    },
    gutter() {
      let row = this.parentRow;
      if (row) {
        return row.gutter;
      }
      return 0;
    },
    // parentRow() {
    //   let row = this.$parent;
    //   let count = 0;
    //   while (row && row.$options.name != "DsfRow") {
    //     row = row.$parent;
    //     count++;
    //     if (count > 10) {
    //       row = null;
    //       return;
    //     }
    //   }
    //   return row;
    // },
    getCss() {
      return [...this.$getClass(), ...this.getSpanNum];
    },
    getStyle() {
      let height = this.height;
      height = this.unitSize(this.height);
      let style = {
        height: height,
        "padding-left": this.unitSize(this.gutter / 2),
        "padding-right": this.unitSize(this.gutter / 2)
      };
      if (!this.isDesign) {
        if (this.parentRow.minHeight) {
          style["min-height"] = this.unitSize(this.parentRow.minHeight);
        }
      }
      return style;
    }
  },
  created() {
    if (!this.isDesign) {
      if (this.$vm && this.local) {
        this.$parent.cols.push(this);
      }
    }
    this.autoHide = _.debounce(() => {
      this.show = !this.checkChildNode();
    }, 1000);
  },
  mounted() {
    if (!this.isDesign && this.height == "auto" && this.parentRow.flex && this.parentRow.autoHideCol && this.parentRow.minHeight != "0") {
      this.createMutationObserver();
    }
  },
  beforeDestroy() {
    this.destroyMutationObserver();
  },
  methods: {
    checkChildNode() {
      let count = 0;
      _.each(this.$el.childNodes, (node) => {
        if ($(node).css("display") == "none") {
          count++;
        }
      });
      return count == this.$el.childNodes.length;
    },
    createMutationObserver() {
      if (window.MutationObserver) {
        const config = { childList: true, attributes: true, subtree: true };
        this.observer = new MutationObserver((mutationsList, observer) => {
          //this?.autoHide?.();
          this.show = !this.checkChildNode();
        });
        this.observer.observe(this.$el, config);
      } else {
        this.$el.addEventListener("DOMSubtreeModified", this.subTreeDomModified);
      }
    },
    subTreeDomModified(evt) {
      this?.autoHide?.();
    },
    destroyMutationObserver() {
      this?.observer?.disconnect?.();
      this?.$el?.removeEventListener?.("DOMSubtreeModified",this.subTreeDomModified);
    },
    resize() {
      // console.log("ssdfsfd")
      // this.show = !this.childrenAllHide;
    }
  }
});
</script>
